import React, { useEffect, useState } from "react";
import { Container, FiltersContainer, FirstLine, SecondLine, Title, } from "./styles";
import DashboardFilters from "../../pages/Dashboard/components/DashboardFilters";
import { connect } from "react-redux";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

function SubHeaderSecondary({ title, renderSide, realtimeRequested, historyRequested,  currentTab }) {
  const [updatedTime, setUpdatedTime] = useState(undefined);

  useEffect(() => {
    if (currentTab.includes('tempo-real')) {
      setUpdatedTime(format(new Date(realtimeRequested), "'Última atualização em' dd/MM/yyyy 'às' HH:mm", { locale: ptBR }))
    }
    if (currentTab.includes('historico')) {
      setUpdatedTime(format(new Date(historyRequested), "'Última atualização em' dd/MM/yyyy 'às' HH:mm", { locale: ptBR }))
    }
  }, [realtimeRequested,historyRequested]);

  return (
    <Container>
      <FirstLine>
        <Title>{title}</Title>
        {updatedTime ? (
          <div>{updatedTime}</div>
        ) : null}
      </FirstLine>
      <SecondLine>
        <FiltersContainer>
          <DashboardFilters currentTab={currentTab} />
        </FiltersContainer>
        {renderSide ? renderSide() : null}
      </SecondLine>
    </Container>
  );
}

const mapStateToProps = state => {
  const nowDatetime = new Date();
  return (
    {
      realtimeRequested: state.dashboardRealTime.onTime.requested || nowDatetime,
      historyRequested: state.dashboardCompleted.bigNumbers.requested || nowDatetime,
    }
  )
};

export default connect(mapStateToProps)(SubHeaderSecondary);
